function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.5 35.83H9.17c-2.3 0-4.17-1.87-4.17-4.17V15c0-2.3 1.87-4.17 4.17-4.17H37.5c2.3 0 4.17 1.87 4.17 4.17v16.67c0 2.29-1.87 4.16-4.17 4.16zM9.17 12.5a2.5 2.5 0 00-2.5 2.5v16.67a2.5 2.5 0 002.5 2.5H37.5a2.5 2.5 0 002.5-2.5V15a2.5 2.5 0 00-2.5-2.5H9.17z",
  fill: "#fff"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.83 39.17H12.5c-2.3 0-4.17-1.87-4.17-4.17 0-.46.37-.83.83-.83.47 0 .84.37.84.83a2.5 2.5 0 002.5 2.5h28.33a2.5 2.5 0 002.5-2.5V18.33a2.5 2.5 0 00-2.5-2.5c-.46 0-.83-.37-.83-.83s.37-.83.83-.83c2.3 0 4.17 1.87 4.17 4.17V35c0 2.3-1.87 4.17-4.17 4.17z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5 32.5c-5.05 0-9.17-4.11-9.17-9.17s4.11-9.17 9.17-9.17c5.05 0 9.17 4.11 9.17 9.17s-4.12 9.17-9.17 9.17zm0-16.67c-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5c4.14 0 7.5-3.36 7.5-7.5s-3.36-7.5-7.5-7.5z",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5 25.83c-2.3 0-4.17-1.87-4.17-4.17s1.87-4.17 4.17-4.17 4.17 1.87 4.17 4.17-1.87 4.17-4.17 4.17zm0-6.66a2.5 2.5 0 000 5 2.5 2.5 0 000-5z",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5 32.5c-2.45 0-4.75-.95-6.48-2.68a.829.829 0 01-.2-.86 7.063 7.063 0 016.67-4.79c3.01 0 5.69 1.93 6.67 4.79.1.3.03.63-.2.86-1.71 1.73-4.01 2.68-6.46 2.68zm-4.9-3.49c2.72 2.36 7.08 2.36 9.81 0-.87-1.92-2.78-3.18-4.9-3.18s-4.04 1.26-4.91 3.18zm24.9-9.84h-8.33c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h8.33c.46 0 .83.37.83.83s-.37.83-.83.83zm0 5h-8.33c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h8.33c.46 0 .83.37.83.83s-.37.83-.83.83zM37.5 29.17h-8.33c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h8.33c.46 0 .83.37.83.83s-.37.83-.83.83z",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/user.8a3c87fd.svg";
export { SvgComponent as ReactComponent };